import { Button } from '@mui/material'
import { withStyles } from '@mui/styles'

const StyledButton = withStyles({
    root: {
        border: 'none',
        backgroundColor: 'white',
        textTransform: 'none',
        color: 'inherit',
        whiteSpace: 'nowrap'
    },
    text: {
        color: '#5A5A5A'
    }
  })(Button);

  export default StyledButton